import { createEntityParamsExpandColumn } from '@/components/entityParams/EntityParamsExpandedHeaders';
import type { DataTableHeader } from '@/types/vuetify';

export function createToolUsersPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        createEntityParamsExpandColumn(),
        {
            title: t('toolUsers.columns.act'),
            tooltip: t('toolUsers.tooltips.column.act'),
            value: 'is_active',
            key: 'is_active',
            align: 'center',
            sortable: false,
            minWidth: 38,
            width: 38,
            cellProps: { class: 'px-0' },
            headerProps: { class: 'px-0' },
        },
        {
            title: t('toolUsers.columns.activation'),
            tooltip: t('toolUsers.tooltips.column.activation'),
            value: 'activation',
            key: 'activation',
            align: 'center',
            sortable: false,
            minWidth: 60,
            nowrap: true,
        },
        {
            title: t('toolUsers.columns.id'),
            value: 'id',
            key: 'id',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 45,
            width: 45,
        },
        {
            title: t('toolUsers.columns.username'),
            value: 'login',
            key: 'login',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('toolUsers.columns.role'),
            tooltip: t('toolUsers.tooltips.column.role'),
            value: 'type_id',
            key: 'type_id',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 30,
            width: 30,
        },
        {
            title: t('toolUsers.columns.c'),
            tooltip: t('toolUsers.tooltips.column.c'),
            value: 'currency_id',
            key: 'currency_id',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 30,
            width: 30,
        },
        {
            title: t('toolUsers.columns.sub'),
            tooltip: t('toolUsers.tooltips.column.sub'),
            value: 'subusers_count',
            key: 'subusers_count',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 40,
            width: 40,
        },
        {
            title: t('toolUsers.columns.createdBy'),
            value: 'user_owner_login',
            key: 'user_owner_login',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 110,
        },
        {
            title: t('toolUsers.columns.date'),
            value: 'created_at',
            key: 'created_at',
            customSortKey: 'id',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 75,
        },
        {
            title: t('toolUsers.columns.lastLogin'),
            value: 'last_login_at',
            key: 'last_login_at',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 75,
        },
        {
            title: t('toolUsers.columns.bots'),
            tooltip: t('toolUsers.tooltips.column.bots'),
            value: 'bots_count',
            key: 'bots_count',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 50,
            width: 50,
        },
        {
            title: t('toolUsers.columns.actBots'),
            tooltip: t('toolUsers.tooltips.column.actBots'),
            value: 'bots_active_count',
            key: 'bots_active_count',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 50,
            width: 50,
        },
        {
            title: t('toolUsers.columns.bets'),
            tooltip: t('toolUsers.tooltips.column.bets'),
            value: 'total_bet_count',
            key: 'total_bet_count',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 50,
            width: 50,
        },
        {
            title: t('toolUsers.columns.lastBet'),
            tooltip: t('toolUsers.tooltips.column.lastBet'),
            value: 'last_bet_at',
            key: 'last_bet_at',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 90,
        },
        {
            title: t('toolUsers.columns.creditLimit'),
            value: 'credit_limit',
            key: 'credit_limit',
            align: 'end',
            sortable: true,
            nowrap: true,
            minWidth: 85,
        },
        {
            title: t('toolUsers.columns.transferBal'),
            tooltip: t('toolUsers.tooltips.column.transferBal'),
            value: 'transfer_balance_amount',
            key: 'transfer_balance_amount',
            align: 'end',
            sortable: true,
            nowrap: true,
            minWidth: 85,
        },
        {
            title: t('toolUsers.columns.betBalance'),
            tooltip: t('toolUsers.tooltips.column.betBalance'),
            value: 'bet_balance_amount',
            key: 'bet_balance_amount',
            align: 'end',
            sortable: true,
            nowrap: true,
            minWidth: 85,
        },
        {
            title: t('toolUsers.columns.balance'),
            tooltip: t('toolUsers.tooltips.column.balance'),
            value: 'total_balance_amount',
            key: 'total_balance_amount',
            align: 'end',
            sortable: true,
            nowrap: true,
            minWidth: 85,
        },
        {
            title: t('toolUsers.columns.exposure'),
            tooltip: t('toolUsers.tooltips.column.exposure'),
            value: 'exposure_amount',
            key: 'exposure_amount',
            align: 'end',
            sortable: true,
            nowrap: true,
            minWidth: 85,
        },
        {
            title: t('toolUsers.columns.credit'),
            tooltip: t('toolUsers.tooltips.column.credit'),
            value: 'credit_amount',
            key: 'credit_amount',
            align: 'end',
            sortable: true,
            nowrap: true,
            minWidth: 85,
        },
        {
            title: t('toolUsers.columns.suspendedShort'),
            tooltip: t('toolUsers.tooltips.column.suspended'),
            value: 'is_suspended',
            key: 'is_suspended',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 38,
            width: 38,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('toolUsers.columns.suspiciousShort'),
            tooltip: t('toolUsers.tooltips.column.suspicious'),
            value: 'is_suspicious',
            key: 'is_suspicious',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 38,
            width: 38,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('toolUsers.columns.verifyEmail'),
            tooltip: t('toolUsers.tooltips.column.verifyEmail'),
            value: 'email_verified_at',
            key: 'email_verified_at',
            align: 'center',
            sortable: false,
            minWidth: 70,
            width: 70,
            nowrap: true,
        },
        {
            title: t('toolUsers.columns.documentsShort'),
            tooltip: t('toolUsers.tooltips.column.documents'),
            value: 'documents',
            key: 'documents',
            align: 'center',
            sortable: false,
            minWidth: 30,
            width: 30,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 72,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
